export default __webpack_public_path__ + "static/media/22.2b7e45f7.png";